import { CustomerPriceItem, CustomerPriceType } from '@/generated/graphql'

const DEFAULT_CUSTOMER_FACING_PRICE_ITEM: CustomerPriceItem = {
  customerPriceType: CustomerPriceType.Customer,
  isCustomerFinalPrice: true,
  price: 0,
  priceExTax: 0,
  priceTaxValue: 0,
}

export const getCustomerFacingPriceItem = (
  customerFacingPriceItems: CustomerPriceItem[] | null | undefined,
): CustomerPriceItem => {
  const item =
    customerFacingPriceItems?.find((entry) => entry?.isCustomerFinalPrice) ??
    DEFAULT_CUSTOMER_FACING_PRICE_ITEM
  return item
}
